import { motion } from "framer-motion";
import { CATEGORIES } from "../../game/categories";

export const CategoryPicker = ({ selected, onSelect }) => (
  <div className="mt-8">
    <div className="mb-3 text-xs font-bold uppercase tracking-[0.2em] text-white/50">Tile category</div>
    <div className="flex flex-wrap gap-2">
      {Object.values(CATEGORIES).map((c) => (
        <motion.button key={c.id} data-testid={`category-${c.id}-btn`} data-selected={selected === c.id ? "true" : "false"} onClick={() => onSelect(c.id)}
          whileHover={{ y: -3 }} whileTap={{ scale: 0.95 }}
          className={`flex items-center gap-2 rounded-full border px-4 py-2 font-display font-bold transition-colors ${selected === c.id ? "border-white/70 bg-gradient-to-r from-cyan-400/30 to-fuchsia-500/30 text-white" : "border-white/10 bg-white/5 text-white/70 hover:bg-white/10"}`}>
          <span className="text-sm opacity-90">{c.sample}</span>
          <span>{c.name}</span>
        </motion.button>
      ))}
    </div>
  </div>
);
